import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

const fetchLearnerHomeInit = async () => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/init/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

export default fetchLearnerHomeInit;
